module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_3009.2da58369.png";